import React from "react";

const TextWithLineBreaks = ({ text } : { text: string }) => (
  <>
    {text.includes('{nl}') ?
      text.split('{nl}').map((item, idx) => (<span key={idx}>{item}<br/></span>)) : text
    }
  </>
)

export default TextWithLineBreaks;